export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const LOGGED_IN = 'LOGGED_IN';
export const SETTINGS = 'SETTING';
// FETCH USER INFO
export const FETCH_USERINFO_REQUEST = 'FETCH_USERINFO_REQUEST';
export const FETCH_USERINFO_SUCCESS = 'FETCH_USERINFO_SUCCESS';
export const FETCH_USERINFO_FAIL = 'FETCH_USERINFO_FAIL';
// FETCH AUTHORIZATION INFO
export const FETCH_AUTHORIZATION_INFO_REQUEST = 'FETCH_AUTHORIZATION_INFO_REQUEST';
export const FETCH_AUTHORIZATION_INFO_SUCCESS = 'FETCH_AUTHORIZATION_INFO_SUCCESS';
export const FETCH_AUTHORIZATION_INFO_FAIL = 'FETCH_AUTHORIZATION_INFO_FAIL';
// FETCH_AUTHORIZATION_LOGIN
export const FETCH_AUTHORIZATION_LOGIN_REQUEST = 'FETCH_AUTHORIZATION_LOGIN_REQUEST';
export const FETCH_AUTHORIZATION_LOGIN_SUCCESS = 'FETCH_AUTHORIZATION_LOGIN_SUCCESS';
export const FETCH_AUTHORIZATION_LOGIN_FAIL = 'FETCH_AUTHORIZATION_LOGIN_FAIL';
// POST_RESET_PASSWORD
export const POST_RESET_PASSWORD_REQUEST = 'POST_RESET_PASSWORD_REQUEST';
export const POST_RESET_PASSWORD_SUCCESS = 'POST_RESET_PASSWORD_SUCCESS';
export const POST_RESET_PASSWORD_FAIL = 'POST_RESET_PASSWORD_FAIL';
// POST_CHANGE_PASSWORD
export const POST_CHANGE_PASSWORD_REQUEST = 'POST_CHANGE_PASSWORD_REQUEST';
export const POST_CHANGE_PASSWORD_SUCCESS = 'POST_CHANGE_PASSWORD_SUCCESS';
export const POST_CHANGE_PASSWORD_FAIL = 'POST_CHANGE_PASSWORD_FAIL';
